import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { Box, Button, Paper, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { TypographyHeading } from "shared/molecules/typography-layout";
import Loader from "pages/build-test/loader";
import SectionTable from "shared/organisms/tables/table";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { useAppDispatch } from "hooks/redux";
import liveClassClientService from "utils/graphql/liveclassClient";
import { GET_SESSION_ATTENDANCE_REPORT } from "utils/graphql/services/live-classes/queries";
import { buildAttendanceRow, table } from "./helper";

export default function AttendanceSummary() {
  const location: any = useLocation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const row = location?.state?.row;
  const liveSessionId = row?.liveSessionId || null;
  const packageScheduleId = row?.id || null;


  const [getAttendanceReport, { loading, data, refetch }] = useLazyQuery(
    GET_SESSION_ATTENDANCE_REPORT,
    {
      client: liveClassClientService,
      fetchPolicy: "no-cache",
      onError: (err: any) => {
        dispatch(
          snackbarRequest({
            message: err?.graphQLErrors?.[0]?.message || "Failed to fetch attendance summary",
            type: "error",
          })
        );
      },
    }
  );

  useEffect(() => {
    if (!row) {
      history.replace(`/live-classes/package-schedules`);
      return;
    }
    if (!liveSessionId || !packageScheduleId) return;
    getAttendanceReport({
      variables: { input: { liveSessionId, packageScheduleId } },
    });
  }, [liveSessionId, packageScheduleId]);

  const tableData = [buildAttendanceRow(row, data?.getSessionAttendanceReport)];

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 2,
          mt: 3,
          mb: 2,
        }}
      >
        <Box>
          <TypographyHeading sx={{ fontSize: "25px" }}>Attendance Summary</TypographyHeading>
          <Typography sx={{ fontSize: "15px", color: "text.secondary", mt: 0.5 }}>
            Attendance rollup for this scheduled class, updated in real time while the class is live.
          </Typography>
        </Box>
      </Box>

      <Paper elevation={2} sx={{ p: 2, mt: 3 }}>
        {loading && !data ? (
          <Loader />
        ) : (
          <SectionTable
            data={tableData}
            table={table}
            id="id"
            name="id"
            rowsPerPageCount={1}
            style="false"
            totalRecords={1}
            paginationSegment="false"
            viewSecondaryData="false"
          />
        )}
      </Paper>
    </>
  );
}
